import { css } from '@emotion/react';
import { ReactElement, ReactNode, useCallback } from 'react';

import { styled } from '../../../../styled';

export type Interface = {
	label: string | ReactNode;
	isOffline?: boolean;
	className: string;
	onChange: (v: boolean) => void;
};

const commonStyles = css`
	align-items: center;
	cursor: pointer;
	display: flex;
	min-height: 18px;
	padding-left: 30px;
	position: relative;

	& input {
		position: absolute;
		left: -99999px;
		height: 0;
		width: 0;
	}

	& > span {
		display: table-cell;
		vertical-align: middle;
		border-radius: 3px;
		border-style: solid;
		border-width: 1px;
		height: 20px;
		left: 0;
		position: absolute;
		top: 0;
		width: 20px;
	}
	& span::after {
		border-style: solid;
		border-width: 0 3px 3px 0;
		bottom: 4px;
		content: '';
		display: none;
		height: 12px;
		left: 6px;
		position: absolute;
		transform: rotate(45deg);
		width: 6px;
	}

	input:checked ~ span:after {
		display: block;
	}
`;

const Component = ({ onChange, className, label }: Interface): ReactElement => {
	const onKeyPress = useCallback(
		(e: React.KeyboardEvent<HTMLInputElement>): void => {
			if (e.key === 'Enter' && e.currentTarget) {
				e.currentTarget.checked = !e.currentTarget.checked;
				onChange(e.currentTarget.checked);
			}
		},
		[onChange]
	);

	return (
		<label className={className}>
			{label}
			<input onChange={(e): void => onChange(e.target.checked)} type="checkbox" onKeyPress={onKeyPress} />
			<span />
		</label>
	);
};

export const Checkbox = styled(Component)(commonStyles);
